<template>
  <CRow>
    <CCol md="12">
      <CCard>
        <header class="card-header">
          <div class="cardHeaderTitleWrapper d-inline-block">
            {{ this.totalCases }} Υποθέσεις
            <div class="small text-muted">{{ todayDate }}</div>
          </div>
          <!-- <CButton color="primary" class="float-right d-inline-block">
            <CIcon name="cil-cloud-download"/>
          </CButton> -->
        </header>
        <CCardBody>
          <CCard>
            <CCardBody>
              <CChartPie
                style="height:450px;width:900px;margin:auto;"
                :datasets="defaultDatasets"
                :labels="['Μη τιμολογημένες', 'Τιμολογημένες', 'Μερικώς εξοφλημένες', 'Πλήρως Εξοφλημένες', 'Τιμολογημένες με Μηδενικό Ποσό']"
              />
            </CCardBody>
          </CCard>
        </CCardBody>
        <CCardFooter>
          <CRow class="text-center">
            <CCol md sm="12" class="mb-sm-2 mb-0">
              <div class="text-muted font-weight-bold">Μη τιμολογημένες Υποθέσεις: <strong class="text-dark">{{ this.totalUnbilledCases+' / '+this.totalCases }}</strong></div>
              <div class="text-muted font-weight-bold">Ποσοστιαία: <strong class="text-dark">{{ this.unbilledCasesPercentage.toFixed(1) }}%</strong></div>
              <CProgress
                class="progress-xs mt-2"
                :precision="1"
                color="secondary"
                :value="this.unbilledCasesPercentage"
              />
            </CCol>
            <CCol md sm="12" class="mb-sm-2 mb-0">
              <div class="text-muted font-weight-bold">Τιμολογημένες Υποθέσεις: <strong class="text-dark">{{ this.totalBilledCases+' / '+this.totalCases }}</strong></div>
              <div class="text-muted font-weight-bold">Ποσοστιαία: <strong class="text-dark">{{ this.billedCasesPercentage.toFixed(1) }}%</strong></div>
              <CProgress
                class="progress-xs mt-2"
                :precision="1"
                color="info"
                :value="this.billedCasesPercentage"
              />
            </CCol>
            <CCol md sm="12" class="mb-sm-2 mb-0">
              <div class="text-muted font-weight-bold">Μερικώς εξοφλημένες Υποθέσεις: <strong class="text-dark">{{ this.totalPartialPayoffCases+' / '+this.totalCases }}</strong></div>
              <div class="text-muted font-weight-bold">Ποσοστιαία: <strong class="text-dark">{{ this.partialPayoffCasesPercentage.toFixed(1) }}%</strong></div>
              <CProgress
                class="progress-xs mt-2"
                :precision="1"
                color="warning"
                :value="this.partialPayoffCasesPercentage"
              />
            </CCol>
          </CRow>
          <CRow class="text-center mt-4">
            <CCol md sm="12" class="mb-sm-2 mb-0">
              <div class="text-muted font-weight-bold">Πλήρως Εξοφλημένες Υποθέσεις: <strong class="text-dark">{{ this.totalFullyPayoffCases+' / '+this.totalCases }}</strong></div>
              <div class="text-muted font-weight-bold">Ποσοστιαία: <strong class="text-dark">{{ this.fullyPayoffCasesPercentage.toFixed(1) }}%</strong></div>
              <CProgress
                class="progress-xs mt-2"
                :precision="1"
                color="success"
                :value="this.fullyPayoffCasesPercentage"
              />
            </CCol>
            <CCol md sm="12" class="mb-sm-2 mb-0">
              <div class="text-muted font-weight-bold">Τιμολογημένες Υποθέσεις με Μηδενικό Ποσό: <strong class="text-dark">{{ this.totalZeroBilledCases+' / '+this.totalCases }}</strong></div>
              <div class="text-muted font-weight-bold">Ποσοστιαία: <strong class="text-dark">{{ this.zeroBilledCasesPercentage.toFixed(1) }}%</strong></div>
              <CProgress
                class="progress-xs mt-2"
                :precision="1"
                color="success"
                :value="this.zeroBilledCasesPercentage"
              />
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { CChartPie } from '@coreui/vue-chartjs'

export default {
  name: 'WidgetsDashboardCases',
  props:{
    billed : {
      type: Object,
      required: true
    }
  },
  components: {
    CChartPie,
  },
  data () {
    return {
      totalUnbilledCases: this.billed.totalUnbilledCases.value,
      totalBilledCases: this.billed.totalBilledCases.value,
      totalPartialPayoffCases:this.billed.totalPartialPayoffCases.value,
      totalFullyPayoffCases: this.billed.totalFullyPayoffCases.value,
      totalZeroBilledCases: this.billed.totalZeroBilledCases.value,

      todayDate: moment(new Date()).format('Do MMMM YYYY')
    }
  },
  computed: {
    defaultDatasets () {
      return [
        {
          backgroundColor: [
            '#ced2d8',
            '#39f',
            '#f9b115',
            '#2eb85c',
            '#20A8D8'
          ],
          data: [this.unbilledCasesPercentage.toFixed(1), this.billedCasesPercentage.toFixed(1), this.partialPayoffCasesPercentage.toFixed(1), this.fullyPayoffCasesPercentage.toFixed(1), this.zeroBilledCasesPercentage.toFixed(1)]
        }
      ]
    },

    totalCases(){
      return this.totalUnbilledCases + this.totalBilledCases + this.totalPartialPayoffCases + this.totalFullyPayoffCases;
    },

    unbilledCasesPercentage(){
      return (this.totalUnbilledCases / this.totalCases) * 100;
    },

    billedCasesPercentage(){
      return (this.totalBilledCases / this.totalCases) * 100;
    },

    partialPayoffCasesPercentage(){
      return (this.totalPartialPayoffCases / this.totalCases) * 100;
    },

    fullyPayoffCasesPercentage(){
      return (this.totalFullyPayoffCases / this.totalCases) * 100;
    },   
    
    zeroBilledCasesPercentage(){
      return (this.totalZeroBilledCases / this.totalCases) * 100;
    },   
  }
}
</script>